import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@/core/store/store'

const resellers = (state: RootState) => state.resellersReducer
export const resellersSelector = createSelector(
  resellers,
  resellersReducer => resellersReducer.resellers,
)
